export default "__VITE_ASSET__uSHHFDX2__"